import { CampoCtxMenu } from './campo-ctx-menu';

export class CtxMenuSezioni {
  inserimento: boolean;
  secondoStadioInserimento: boolean;
  showMenu: boolean;
  upperList: CampoCtxMenu[];
  lowerList: CampoCtxMenu[];
}
